import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"

import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import ReactExport from "react-data-export"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
})

class ChangeOrgan extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)

            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 5,
                  page: 0,
                  organ_id: "",
                  organ_pass: "",
                  organ_name: "",
                  organ_username: "",
                  organ_agentmobile: "",
                  organ_tell: "",
                  organ_managemobile: "",
                  organ_agent: "",
                  organ_address: "",
                  agent_banknum: "",
                  agent_banksheba: "",
                  agent_city_name: "",
                  organ_deactive: "1",
                  organ_logo: "",
                  agent_company_logo_url: "",
                  orderBy: "organ_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newOrgan: true,
                  picturesRequestReady: "",
                  imageCode: "",

                  loading: false,
                  percent: 0,
                  selectedFilterDeactive: "",
                  idFilter: "",
                  codeFilter: "",
                  nameFilter: "",
                  familyFilter: "",
                  mobileFilter: "",
                  showPaperChart: false,
                  showEnterOrgan: false,
            }
      }

      handleShowPaperChart = (event) => {
            this.setState({ showPaperChart: true })
      }

      handleHidePaperChart = (event) => {
            this.setState({ showPaperChart: false })
      }

      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }

      handleChangeName = (event) => {
            this.setState({ organ_name: event.target.value })
      }
      handleChangCode = (event) => {
            this.setState({ organ_pass: event.target.value })
      }
      handleChangeUserName = (event) => {
            this.setState({ organ_username: event.target.value })
      }

      handleChangeMobile = (event) => {
            this.setState({ organ_agentmobile: event.target.value })
      }

      handleChangeTell = (event) => {
            this.setState({ organ_tell: event.target.value })
      }
      handleChangeTellRequir = (event) => {
            this.setState({ organ_managemobile: event.target.value })
      }
      handleChangeEmail = (event) => {
            this.setState({ organ_agent: event.target.value })
      }
      handleChangeAddress = (event) => {
            this.setState({ organ_address: event.target.value })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ organ_deactive: "0" })
            } else {
                  this.setState({ organ_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        organ_pass: row2.organ_pass,
                        organ_id: row2.organ_id,
                        organ_name: row2.organ_name,
                        organ_username: row2.organ_username,
                        organ_agentmobile: row2.organ_agentmobile,
                        organ_tell: row2.organ_tell,
                        organ_managemobile: row2.organ_managemobile,
                        organ_agent: row2.organ_agent,
                        organ_address: row2.organ_address,
                        organ_deactive: row2.organ_deactive,
                        organ_logo: row2.organ_logo,
                        newOrgan: false,
                        imageCode: "",
                        showEnterOrgan: true,
                  },
                  () => {}
            )
      }

      newOrganFunc = (event) => {
            this.setState({
                  organ_id: "",
                  organ_pass: "",
                  organ_name: "",
                  organ_username: "",
                  organ_agentmobile: "",
                  organ_tell: "",
                  organ_managemobile: "",
                  organ_agent: "",
                  organ_address: "",
                  organ_deactive: "0",
                  organ_logo: "",
                  agent_company_logo_url: "",
                  imageCode: "",
                  newOrgan: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getOrgan()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getOrgan() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        } else if (arr.result === "eror") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_organ")

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      uploadPicDelivery = (mode) => {
            const {
                  organ_name,
                  organ_username,
                  organ_pass,
                  organ_agentmobile,
                  organ_tell,
                  organ_managemobile,
                  organ_address,
                  organ_deactive,
            } = this.state
            const { picturesRequestReady } = this.state
            if (
                  organ_pass != "" &&
                  organ_name != "" &&
                  organ_username != "" &&
                  organ_agentmobile != "" &&
                  organ_tell != "" &&
                  organ_address != "" &&
                  organ_deactive != ""
            ) {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewOrgan(arr.data["image_code"])
                                          } else {
                                                self.changeOrgan(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر ارگان")
                        fd.append("image_desc", "تصویر ارگان")
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        if (mode === "new") {
                              this.saveNewOrgan("")
                        } else {
                              this.changeOrgan("")
                        }
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات ارگان را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewOrgan = (imageCode) => {
            const {
                  organ_name,
                  organ_username,
                  organ_pass,
                  organ_agentmobile,
                  organ_tell,
                  organ_managemobile,
                  organ_agent,
                  organ_address,
                  organ_deactive,
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getOrgan()
                              self.newOrganFunc()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_organ")
            fd.append("organ_name", organ_name)
            fd.append("organ_pass", organ_pass)
            fd.append("organ_username", organ_username)
            fd.append("organ_agentmobile", organ_agentmobile)
            fd.append("organ_tell", organ_tell)
            fd.append("organ_managemobile", organ_managemobile)
            fd.append("organ_agent", organ_agent)
            fd.append("organ_address", organ_address)
            fd.append("organ_deactive", organ_deactive)
            fd.append("organ_logo", imageCode)

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeOrgan = (imageCode) => {
            const {
                  organ_id,
                  organ_pass,
                  organ_name,
                  organ_username,
                  organ_agentmobile,
                  organ_tell,
                  organ_managemobile,
                  organ_agent,
                  organ_address,
                  organ_deactive,
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getOrgan()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_organ")
            fd.append("organ_id", organ_id)
            fd.append("organ_name", organ_name)
            fd.append("organ_pass", organ_pass)
            fd.append("organ_username", organ_username)
            fd.append("organ_agentmobile", organ_agentmobile)
            fd.append("organ_tell", organ_tell)
            fd.append("organ_managemobile", organ_managemobile)
            fd.append("organ_agent", organ_agent)
            fd.append("organ_address", organ_address)
            fd.append("organ_deactive", organ_deactive)
            if (imageCode !== "") {
                  fd.append("organ_logo", imageCode)
            }

            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      getCity = (state_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State
                              if (self.state.optionFilterCity.length > 0) {
                                    var State = self.state.optionFilterCity
                              } else {
                                    var State = []
                              }
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionFilterCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", state_id)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      handleFilterDeactive = (selectedFilterDeactive) => {
            this.setState({ selectedFilterDeactive: selectedFilterDeactive }, () => {})
      }
      handleFilterStatus = (selectedFilterStatus) => {
            this.setState({ selectedFilterStatus: selectedFilterStatus }, () => {})
      }
      handleChangeFilterId = (event) => {
            this.setState({ idFilter: event.target.value }, () => {})
      }

      handleChangeFilterCode = (event) => {
            this.setState({ codeFilter: event.target.value }, () => {})
      }

      handleChangeFilterName = (event) => {
            this.setState({ nameFilter: event.target.value }, () => {})
      }
      handleChangeFilterUserName = (event) => {
            this.setState({ familyFilter: event.target.value }, () => {})
      }
      handleChangeFilterMobile = (event) => {
            this.setState({ mobileFilter: event.target.value }, () => {})
      }
      filterFunc = () => {
            const {
                  requestinfos,
                  agentInfofilter,
                  selectedFilterState,
                  selectedFilterCity,
                  selectedFilterCompany,
                  idFilter,
                  codeFilter,
                  nameFilter,
                  familyFilter,
                  mobileFilter,
                  selectedFilterDeactive,
                  selectedFilterStatus,
            } = this.state
            var i, j, temparray2, temparray, b1, b2, b3
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < requestinfos.length; i++) {
                  if (
                        ((idFilter !== "" && temparray[i].organ_id.includes(idFilter)) || idFilter === "") &&
                        ((codeFilter !== "" && temparray[i].organ_pass.includes(codeFilter)) || codeFilter === "") &&
                        ((nameFilter !== "" && temparray[i].organ_name.includes(nameFilter)) || nameFilter === "") &&
                        ((familyFilter !== "" && temparray[i].organ_username.includes(familyFilter)) || familyFilter === "") &&
                        ((mobileFilter !== "" && temparray[i].organ_agentmobile.includes(mobileFilter)) || mobileFilter === "") &&
                        ((selectedFilterDeactive !== "" && temparray[i].organ_deactive === selectedFilterDeactive.value) ||
                              selectedFilterDeactive === "" ||
                              selectedFilterDeactive.value === "10")
                  ) {
                        b1 = false
                        b2 = false
                        b3 = false

                        if (selectedFilterState.length === 0) {
                              b1 = true
                        } else {
                              for (j = 0; j < selectedFilterState.length; j++) {
                                    if (temparray[i].agent_state_id === selectedFilterState[j].value) {
                                          b1 = true
                                    }
                              }
                        }
                        if (selectedFilterCity.length === 0) {
                              b2 = true
                        } else {
                              for (j = 0; j < selectedFilterCity.length; j++) {
                                    if (temparray[i].agent_city_id === selectedFilterCity[j].value) {
                                          b2 = true
                                    }
                              }
                        }
                        if (selectedFilterCompany.length === 0) {
                              b3 = true
                        } else {
                              for (j = 0; j < selectedFilterCompany.length; j++) {
                                    if (temparray[i].agent_company_id === selectedFilterCompany[j].value) {
                                          b3 = true
                                    }
                              }
                        }
                        if (b1 && b2 && b3) {
                              temparray2.push(temparray[i])
                        }
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }
      ClearFilter = () => {
            this.setState({
                  selectedFilterCompany: [],
                  selectedFilterState: [],
                  selectedFilterCity: [],
                  selectedFilterDeactive: "",
                  selectedFilterStatus: "",
                  idFilter: "",
                  codeFilter: "",
                  nameFilter: "",
                  familyFilter: "",
                  mobileFilter: "",
                  optionFilterCity: [],
                  selectedOptionCity: [],
                  selectedOptionState: [],
                  agentInfofilter: this.state.requestinfos,
            })
      }
      HandelShowEnterOrgan = () => {
            this.setState({
                  showEnterOrgan: true,
            })
            this.newOrganFunc()
      }
      handleHideEnterOrgan = () => {
            this.setState({
                  showEnterOrgan: false,
            })
      }
      render() {
            const { classes } = this.props
            const {
                  showEnterOrgan,
                  showPaperChart,
                  mobileFilter,
                  familyFilter,
                  nameFilter,
                  codeFilter,
                  idFilter,
                  selectedFilterDeactive,
                  selectedFilterStatus,
                  loading,
                  percent,
                  snackMode,
                  snackstr,
                  showSnack,
                  newOrgan,
                  organ_id,
                  organ_pass,
                  organ_name,
                  organ_username,
                  organ_logo,
                  agent_company_logo_url,
                  organ_agentmobile,
                  organ_tell,
                  organ_managemobile,
                  organ_agent,
                  organ_address,
                  organ_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      {showEnterOrgan ? (
                                                            <Button variant="outlined" color="primary" onClick={this.handleHideEnterOrgan}>
                                                                  {"مخفی کردن"}
                                                            </Button>
                                                      ) : (
                                                            <Button variant="outlined" color="primary" onClick={this.HandelShowEnterOrgan}>
                                                                  {"ارگان جدید"}
                                                            </Button>
                                                      )}
                                                      <Collapse in={showEnterOrgan}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"آی دی ارگان : " + organ_id}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <Avatar alt="Remy Sharp" className={classes.large} src={organ_logo} />
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={6}>
                                                                        <Grid container spacing={3}>
                                                                              <Grid item xs={9}>
                                                                                    <FloatingLabelInput
                                                                                          placeholder="نام ارگان"
                                                                                          handleInputt={this.handleChangeName}
                                                                                          value={organ_name}
                                                                                    />
                                                                              </Grid>
                                                                        </Grid>
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام کاربری"
                                                                              handleInputt={this.handleChangeUserName}
                                                                              value={organ_username}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شماره همراه کاربر "
                                                                              handleInputt={this.handleChangeMobile}
                                                                              value={organ_agentmobile}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شماره ثابت ارگان "
                                                                              handleInputt={this.handleChangeTell}
                                                                              value={organ_tell}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام کارمند"
                                                                              handleInputt={this.handleChangeEmail}
                                                                              value={organ_agent}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder=" همزاه مدیریت "
                                                                              handleInputt={this.handleChangeTellRequir}
                                                                              value={organ_managemobile}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="پسورد ارگان"
                                                                              handleInputt={this.handleChangCode}
                                                                              value={organ_pass}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <FloatingLabelInput
                                                                              placeholder="آدرس سازمان"
                                                                              handleInputt={this.handleChangeAddress}
                                                                              value={organ_address}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <ImageUploader
                                                                              withIcon={true}
                                                                              buttonText="عکس را انتخاب نمایید"
                                                                              onChange={this.onSelectPicRequest}
                                                                              withPreview="true"
                                                                              singleImage="true"
                                                                              imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                              maxFileSize={5242880}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <FormControlLabel
                                                                                    control={
                                                                                          <Switch
                                                                                                checked={organ_deactive === "0" ? true : false}
                                                                                                onChange={this.handleChangeDeactive}
                                                                                                name="gilad"
                                                                                          />
                                                                                    }
                                                                                    label="وضعیت فعالیت ارگان"
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        {loading && <LinearProgress variant="determinate" value={percent} />}
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        {newOrgan ? (
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("new")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت ارگان جدید "}
                                                                              </Button>
                                                                        ) : (
                                                                              <div style={{ width: "100%", textAlign: "right" }}>
                                                                                    <Button
                                                                                          variant="outlined"
                                                                                          color="primary"
                                                                                          onClick={this.newOrganFunc}
                                                                                    >
                                                                                          {"ارگان جدید"}
                                                                                    </Button>
                                                                                    {"          "}
                                                                                    <Button
                                                                                          variant="outlined"
                                                                                          color="primary"
                                                                                          onClick={(e) => {
                                                                                                this.uploadPicDelivery("modify")
                                                                                          }}
                                                                                    >
                                                                                          {"ثبت تغییرات"}
                                                                                    </Button>
                                                                              </div>
                                                                        )}
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "left" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.handleHideEnterOrgan}
                                                                              >
                                                                                    {"مخفی کردن"}
                                                                              </Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>
                                                      </Collapse>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      {showPaperChart ? (
                                                            <Button variant="outlined" color="primary" onClick={this.handleHidePaperChart}>
                                                                  {"مخفی کردن"}
                                                            </Button>
                                                      ) : (
                                                            <Button variant="outlined" color="primary" onClick={this.handleShowPaperChart}>
                                                                  {"جستجو"}
                                                            </Button>
                                                      )}

                                                      <Collapse in={showPaperChart}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                              placeholder="آی دی ارگان"
                                                                              value={idFilter}
                                                                              handleInputt={this.handleChangeFilterId}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                              placeholder="کد ارگان"
                                                                              value={codeFilter}
                                                                              handleInputt={this.handleChangeFilterCode}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام ارگان "
                                                                              value={nameFilter}
                                                                              handleInputt={this.handleChangeFilterName}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام کاربری"
                                                                              value={familyFilter}
                                                                              handleInputt={this.handleChangeFilterUserName}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="همراه کاربر"
                                                                              value={mobileFilter}
                                                                              handleInputt={this.handleChangeFilterMobile}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div>
                                                                              <label className="on">وضعیت فعالیت ارگان</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"وضعیت فعالیت ارگان"}
                                                                                    value={selectedFilterDeactive}
                                                                                    onChange={this.handleFilterDeactive}
                                                                                    options={[
                                                                                          { value: "10", label: "هر دو وضعیت" },
                                                                                          { value: "0", label: "فعال" },
                                                                                          { value: "1", label: "غیر فعال" },
                                                                                    ]}
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div>
                                                                              <label className="on">وضعیت آنلاین ارگان</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"وضعیت آنلاین ارگان"}
                                                                                    value={selectedFilterStatus}
                                                                                    onChange={this.handleFilterStatus}
                                                                                    options={[
                                                                                          { value: "10", label: "هر دو وضعیت" },
                                                                                          { value: "0", label: "آفلاین" },
                                                                                          { value: "1", label: "آنلاین" },
                                                                                    ]}
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Button variant="outlined" color="primary" onClick={this.filterFunc}>
                                                                              {"جستجو "}
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <Button variant="outlined" color="primary" onClick={this.ClearFilter}>
                                                                              {"پاک کردن فیلتر ها "}
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.handleHidePaperChart}
                                                                        >
                                                                              {"مخفی کردن"}
                                                                        </Button>
                                                                  </Grid>
                                                            </Grid>
                                                      </Collapse>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell>
                                                                                    <ExcelFile
                                                                                          element={
                                                                                                <Button variant="outlined" color="primary">
                                                                                                      {" "}
                                                                                                      {"اکسل "}
                                                                                                </Button>
                                                                                          }
                                                                                    >
                                                                                          <ExcelSheet data={agentInfofilter} name="نمایندگان">
                                                                                                <ExcelColumn label="آی دی" value="organ_id" />
                                                                                                <ExcelColumn label="نام ارگان" value="organ_name" />
                                                                                                <ExcelColumn
                                                                                                      label="نام کاربری"
                                                                                                      value="organ_username"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره همراه کاربر"
                                                                                                      value="organ_agentmobile"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره ثابت ارگان"
                                                                                                      value="organ_tell"
                                                                                                />
                                                                                                <ExcelColumn label="نام کارمند" value="organ_agent" />
                                                                                                <ExcelColumn
                                                                                                      label="همزاه مدیریت"
                                                                                                      value="organ_managemobile"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="آدرس سازمان"
                                                                                                      value="organ_address"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="وضعیت فعالیت "
                                                                                                      value={(col) =>
                                                                                                            col.organ_deactive === "1"
                                                                                                                  ? "غیر فعال"
                                                                                                                  : "فعال"
                                                                                                      }
                                                                                                />
                                                                                          </ExcelSheet>
                                                                                    </ExcelFile>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "organ_id" ? order : false}
                                                                              >
                                                                                    {" شماره ارگان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_id"}
                                                                                          direction={orderBy === "organ_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_agent"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "organ_agent" ? order : false}
                                                                              >
                                                                                    {"نام کارمند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_agent"}
                                                                                          direction={orderBy === "organ_agent" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_agent")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"organ_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام ارگان  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_name"}
                                                                                          direction={orderBy === "organ_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_managemobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"همراه مدیر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_managemobile"}
                                                                                          direction={orderBy === "organ_managemobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_managemobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_agentmobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شماره همراه کاربر "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_agentmobile"}
                                                                                          direction={orderBy === "organ_agentmobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_agentmobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت فعالیت ارگان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_deactive"}
                                                                                          direction={orderBy === "organ_deactive" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["organ_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <Avatar
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["organ_logo"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"organ_id"} align={"center"}>
                                                                                                      {row["organ_id"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"organ_agent"} align={"center"}>
                                                                                                      {row["organ_agent"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"organ_name"} align={"center"}>
                                                                                                      {row["organ_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"organ_managemobile"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["organ_managemobile"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_agentmobile"} align={"center"}>
                                                                                                      {row["organ_agentmobile"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_deactive"} align={"center"}>
                                                                                                      {row["organ_deactive"] === "1" ||
                                                                                                      row["organ_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeOrgan)
